import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

// axios.defaults.withCredentials = true

export const setUserStatusSlice = createAsyncThunk(
    'userData',
    async (li, thunkAPI) => {
      try {

        return li
      } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message })
      }
    }
  )

export const selectUserSlice = (state) => state.userSlice
  
  const userSlice = createSlice({
    name: 'userData',
    initialState: {
      id: '',
      username: '',
      email: '',
    },
    extraReducers: (builder) => {
      builder.addCase(setUserStatusSlice.fulfilled, (state, { payload }) => {
        if(payload.length !== 0) {
          state.id = payload[0].id
          state.username = payload[0].username
          state.email = payload[0].email
        }
      })
    },
  })


export default userSlice